/**
 * Global Imports
*/

import PropTypes from 'prop-types';
import React from 'react';

/**
 * Root Imports
*/

import { CssClassName } from '~/util/Css';

/**
 * Local Imports
*/

import { LabeledField } from './LabeledField';

/**
 * Exports
*/

/**
 * 
 */
export function Input({ className, ...props }) {
  /** Settings **/

  const config = {
    name: props.name,
    className: CssClassName(className),
    type: props.type,
    placeholder: props.placeholder,
    autoComplete: props.autoComplete
  };
  
  /** Output **/

  return (
    <LabeledField { ...props }>
      <input { ...config } />
    </LabeledField>
  );
}

Input.propTypes = {
  name: PropTypes.string.isRequired,
  type: PropTypes.string,
  className: PropTypes.oneOfType([ PropTypes.string, PropTypes.array ]),
  containerClassName: PropTypes.oneOfType([ PropTypes.string, PropTypes.array ]),
  label: PropTypes.string,
  autoComplete: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  formik: PropTypes.object
};

Input.defaultProps = {
  type: 'text',
  autoComplete: 'on'
};